import { render, staticRenderFns } from "./PageTemplateLeftMenuAndBody.vue?vue&type=template&id=0ac55b47&scoped=true"
import script from "./PageTemplateLeftMenuAndBody.vue?vue&type=script&lang=js"
export * from "./PageTemplateLeftMenuAndBody.vue?vue&type=script&lang=js"
import style0 from "./PageTemplateLeftMenuAndBody.vue?vue&type=style&index=0&id=0ac55b47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac55b47",
  null
  
)

export default component.exports